import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'

//tailwind
import './tailwind/index.css'

createApp(App).use(router).mount('#app')
